import styled from "styled-components";
import { deviceSizesMin } from "../../../../DeviceSizes";

export const ArticleListContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;

  padding: 0 30px 50px 30px;
  margin: 40px auto auto auto;

  width: 100%;

  @media only screen and ${deviceSizesMin.laptop} {
    width: 100%;
  }

  @media only screen and ${deviceSizesMin.laptopL} {
    width: 1170px;

    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    padding: 0px 30px 50px 30px;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const ArticleCardLink = styled.a`
  height: 240px;
  flex: 0 1 240px;
  margin-right: auto;
  margin-left: auto;
  margin-bottom: 40px;

  @media only screen and ${deviceSizesMin.mobileM} {
    height: 300px;
    flex: 0 1 300px;
    margin-right: auto;
    margin-left: auto;
  }

  @media only screen and ${deviceSizesMin.laptop} {
    height: 350px;
    flex: 0 1 350px;

    position: relative;
    margin-bottom: 30px;
  }
`;

export const ArticleCardContainer = styled.div`
  position: relative;
  background: url(${(props) => props.image}) no-repeat center center;
  background-size: cover;
  height: 100%;
  width: 100%;
  border-radius: 10px;

  cursor: pointer;

  &:hover,
  &:focus {
    transform: scale(1.05);
    transition: 0.2s all;
  }
`;

export const ArticleCardOverlay = styled.div`
  background: rgba(0, 0, 0, 0.75);
  color: white;
  max-height: 150px;
  min-height: 50px;

  border-bottom-right-radius: 10px;

  position: absolute;
  bottom: 0;
  right: 0;

  @media only screen and ${deviceSizesMin.mobileL} {
    width: 300px;
  }
`;

export const ArticleCardTitle = styled.h2`
  margin: 2px 2px 2px 0;
  font-size: 16px;
  text-align: center;
  line-height: 20px;
  display: inline-block;
  font-weight: 600;
  letter-spacing: 1.5px;
  width: 100%;
`;

export const ArticleCardMeta = styled.p`
  font-size: 14px;
  padding: 5px;
  text-align: center;
`;
